import "./NotesPreview.css";

import { convertDateToStringDDMMYYYY } from "../../../../utils";
import { InteractionNote } from "../../models";

interface NotesPreviewProps {
  notes: InteractionNote[];
  maxItems?: number;
  emptyText?: string;
}

export const NotesPreview = ({ notes, maxItems = 3, emptyText = "No notes yet" }: NotesPreviewProps): JSX.Element => {
  if (!notes.length) {
    return <p className="body2Light NotesPreviewEmpty">{emptyText}</p>;
  }

  return (
    <div className="NotesPreviewList">
      {notes.slice(0, maxItems).map((note) => (
        <div key={note.uuid} className="NotesPreviewItem">
          <div className="NotesPreviewHeader">
            <p className="body2 NotesPreviewTitle">{note.data.title}</p>
            <p className="body2Light NotesPreviewDate">{convertDateToStringDDMMYYYY(note.createdAt)}</p>
          </div>
          <p className="body2Light NotesPreviewContent">{note.data.content}</p>
        </div>
      ))}
    </div>
  );
};
